import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  width: 100%;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const CountryInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const PercentageAndTag = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const ProgressTrack = styled.div`
  width: 100%;
  height: 6px;
  border-radius: ${props => props.theme.primitives.radius.radius4};
  background-color: ${props => props.theme.colors.disabled.surface};
  overflow: hidden;
`

export const ProgressFiller = styled.div`
  height: 100%;
  border-radius: ${props => props.theme.primitives.radius.radius4};
  background-color: ${props => props.fillColor};
  width: ${props => props.widthPercentage}%;
`
